import { ReactElement } from "react";
import { ImgSgv } from "../../../Login/stylesLogin";
import {
  ComponentContentBox,
  GradienteDowBox,
  SectionBox,
  SectionBoxTitle,
  SectionBoxTitleIcon,
} from "./styles";

interface BoxReportProps {
  title: string;
  ImgSgvIco: string;
  InternalComponent: ReactElement<any, any>;
}

export const BoxReport: React.FC<BoxReportProps> = ({
  title,
  InternalComponent,
  ImgSgvIco,
}) => {
  return (
    <SectionBox>
      <SectionBoxTitle>
        <SectionBoxTitleIcon>
          <ImgSgv
            style={{ marginRight: "10px" }}
            width={26}
            src={ImgSgvIco}
          />
          <h4
            style={{
              fontStyle: "bold",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "24px",
              color: "#333",
            }}
          >
            {title}
          </h4>
        </SectionBoxTitleIcon>
      </SectionBoxTitle>
      <br />
      <GradienteDowBox />
      <ComponentContentBox>{InternalComponent}</ComponentContentBox>
    </SectionBox>
  );
};
